<template>
  <div class="share d-lg-none">
    <button
      class="share-btn"
      type="button"
      :aria-label="$t('common:share.share')"
      @click="$modal.show('objectShareModal')"
    >
      <i class="icon"><icon-share /></i>
    </button>
  </div>
</template>

<script>
import IconShare from 'ICON:IconShare';

export default {
  name: 'ShareBtn',
  i18nOptions: { namespaces: 'common' },
  components: {
    IconShare,
  },
};
</script>

<style lang="scss" scoped>
.share {
  width: 50px;
  height: 50px;
  line-height: 1em;
  position: relative;
  top: 10px;
  z-index: 1000;
  display: inline-block;
  outline: none;

  @include font_size_xxl;

  .share-btn {
    width: 50px;
    height: 50px;
    background: transparent;
    border: none;

    i {
      height: inherit;
      width: inherit;
      color: #fff;
      position: absolute;
      top: 0;
      right: 0;
      padding-top: 9px;

      &.icon {
        @include drop_shadow_strong;
      }
    }
  }

}
</style>
